module.exports = __webpack_public_path__ + "img/ExamplePicOCA-min.46e4f98d.jpg";